<script>
import youtubeContainerShorts from '@/components/youtubeContainerShorts.vue';

export default {
  name: 'album15',
  components: {
    youtubeContainerShorts
  },
  data() {
    return {
      ready: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.ready = true;
    }
  },
};
</script>

<template>
  <div class="uncommon-container" v-if="ready" :class="$mq">
    <div class="contents-container short">
      <div class="movie-container">
        <youtube-container-shorts
          :file-url="'DDVvCYHXMF8'"
          :is-close-btn-white="true"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  @import "../css/albumUncommon";
</style>
